var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5954 15.7153C10.7585 16.5576 9.84471 16.4246 8.9651 16.0256C8.03425 15.6178 7.18026 15.6 6.19818 16.0256C4.96843 16.5753 4.3194 16.4157 3.58497 15.7153C-0.58249 11.2555 0.0323821 4.46393 4.76348 4.21567C5.91636 4.27773 6.71911 4.87178 7.39376 4.92498C8.40147 4.71218 9.36648 4.10041 10.4425 4.18021C11.732 4.2866 12.7056 4.81858 13.3461 5.77614C10.6816 7.43414 11.3136 11.0782 13.756 12.0978C13.2692 13.4278 12.6373 14.7489 11.5868 15.7242L11.5954 15.7153ZM7.30836 4.16247C7.18026 2.18528 8.72598 0.553881 10.5023 0.394287C10.7499 2.6818 8.50395 4.38413 7.30836 4.16247Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.3c215ff7b9a3527ba57e41cb93bc5671.svg";
export { ForwardRef as ReactComponent };